import axios from 'axios';
import { getAuthSession } from './auth';
import mixpanel from 'mixpanel-browser';
import { attachMutationReporter } from './lib/mutation-reporter';

function createClient(accessToken) {
	const client = axios.create({
		headers: {
			...(accessToken && { Authorization: `Bearer ${accessToken}` })
		}
	});

	// Failed writes are otherwise swallowed by the mutation-hook → toast path and
	// never reach Sentry. Observe-only — the rejection is re-thrown untouched.
	return attachMutationReporter(client);
}

export default async function myShopClient() {
	const { email, token } = await getAuthSession();
	if (email?.includes('@near.st')) {
		// Disable Mixpanel tracking for internal accounts
		mixpanel.disable();
	}
	return createClient(token);
}

/**
 * For the handful of pre-auth writes (signup, lead capture), so their failures
 * are reported like every other mutation. The presigned-S3 uploads stay on
 * bare axios deliberately — their callers capture failures themselves.
 */
export const unauthenticatedClient = attachMutationReporter(axios.create());
